import {Routes} from '@angular/router';

export const goodszoneRecommendationRoutes: Routes = [
  {
    path: 'goodszoneRecommendation',
    loadComponent: () => import('./goodszone-recommendation.component').then(m => m.GoodszoneRecommendationComponent),
    data: { title: '拼套装橱窗' },
  },
];
